<template>
  <div class="section text-black pt-0 pt-lg-3">
    <div class="container">
      <div>
        <div>
          <h2 class="title pt-0 mobile-title my-1 mb-3">DOVE SIAMO?</h2>
          <div class="col-12 text-center mb-4">
            <i class="fa fa-map-pin fa-sm px-1 indianRedColor"></i> Ci puoi
            trovare in
            <u v-if="isGeodidalab"
              ><a
                class="a_collapse"
                href="https://www.google.com/maps/dir/?api=1&amp;destination=45.477466179593%2C7.8914880752563"
                >Via Lago S. Michele, 15 10015 Ivrea, Piemonte</a
              ></u
            >
            <u v-else
              ><a
                class="a_collapse"
                href="https://www.google.com/maps/dir/?api=1&amp;destination=45.477466179593%2C7.8914880752563"
                >Alagna Valsesia VC, 13021</a
              ></u
            >
          </div>
          <div class="px-4">
            <l-map
              class="mappaDoveSiamo"
              :zoom="zoom"
              :center="
                isGeodidalab
                  ? markerLatLngGeodidalab
                  : markerLatLngIstitutoMosso
              "
            >
              <l-tile-layer
                :url="url"
                :attribution="attribution"
              ></l-tile-layer>

              <l-marker
                :lat-lng="
                  isGeodidalab
                    ? markerLatLngGeodidalab
                    : markerLatLngIstitutoMosso
                "
              >
                <l-popup :options="anchorOptions">
                  <div class="px-3">
                    <div class="row">
                      <h5 v-if="isGeodidalab">Geodidalab</h5>
                      <h5 v-else>Istituto Angelo Mosso</h5>
                    </div>
                  </div>
                </l-popup>
                <l-icon
                  :icon-url="require('../icons/unselectedPOI.svg')"
                ></l-icon>
              </l-marker>
            </l-map>
          </div>
        </div>
      </div>

      <div class="row text-center" v-if="places.length > 0">
        <div class="col-md-6 ml-auto mr-auto">
          <h4 class="title text-center pt-0">I nostri luoghi</h4>
        </div>
        <div class="col-12 ml-auto mr-auto">
          <ul :class="isLarge ? 'tab mb-4' : 'tab_mobile mb-4'">
            <li
              v-for="(place, index) in places"
              :key="index"
              :class="
                selectedTab === place
                  ? 'tag__item__selected'
                  : 'tag__item__unselected'
              "
              v-on:click="changePlace(place)"
            >
              {{ place }}
            </li>
          </ul>
        </div>
      </div>
      <div v-if="allLoaded">
        <div class="row" v-for="(place, index) in places" :key="index">
          <div class="col-12">
            <div v-if="selectedTab === place">
              <div class="row" v-if="(place === 'Webcam' && !isGeodidalab)">
                <div class="col-12">
                  <div
                    class="text-center my-4 mx-0 p-0"
                    v-for="(webcam, index) in filteredMediaWebcam(place)"
                    :key="index"
                  >
                    <div style="padding-bottom:56.25%; position:relative; display:block; width: 100%" v-if="isLarge">
                      <iframe width="100%" height="100%"
                              :id="'webcam' + index"
                              class="customiframe"
                              :src="webcam['dcterms:description'][0]['@value']"
                              frameborder="0" allowfullscreen="" style="position:absolute; top:0; left: 0"
                              onload="resizeIframe(this)" >
                      </iframe>
                    </div>
                    <div style="padding-bottom:56.25%; position:relative; display:block; width: 100%; height: 500px" v-else>
                      <iframe width="100%" height="500px"
                              :id="'webcam' + index"
                              class="customiframe"
                              :src="webcam['dcterms:description'][0]['@value']"
                              frameborder="0" allowfullscreen="" style="position:absolute; top:0; left: 0"
                              onload="resizeIframe(this)">
                      </iframe>
                    </div>
                    <!--<iframe width="100%" v-resize="{ log: true }"
                            :id="'webcam' + index"
                            class="customiframe"
                            :src="webcam['dcterms:description'][0]['@value']"
                            frameborder="0"></iframe>-->
                    <!--<div class="frame-container">
                      <iframe
                          class="customiframe"
                          :id="'webcam' + index"
                          width="1000"
                          height="750"
                          :src="webcam['dcterms:description'][0]['@value']"
                          title="Webcam"
                          frameborder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowfullscreen
                      ></iframe>
                    </div>-->
                  </div>
                </div>
              </div>
              <div class="row" v-if="panorama !== null">
                <div class="col-12 my-3 mx-auto text-center">
                  <div
                    class=""
                    :style="isLarge ? 'height: 700px' : 'height: 300px;'"
                  >
                    <h5 class="mobile-subtitle">
                      Esplora i nostri luoghi a 360 gradi!
                    </h5>
                    <Pano :source="panorama"> </Pano>
                  </div>
                </div>
              </div>

              <div class="row">
                <div
                  v-if="isLarge"
                  class="col-md-10 ml-auto mr-auto collections"
                >
                  <ul
                    style="display: grid; grid-template-columns: repeat(2, 1fr)"
                    class="p-0"
                  >
                    <li
                      v-for="(item, index) in filteredMedia(place)"
                      :key="index"
                      class="m-3 d-inline"
                    >
                      <img
                        class="w-100 h-100"
                        v-bind:src="item['thumbnail_display_urls']['large']"
                        v-img="{ group: getTitle(item) }"
                        :alt="getTitle(item)"
                        :title="getTitle(item)"
                      />
                    </li>
                  </ul>
                  <ul
                    v-if="lastItem"
                    style="display: grid; grid-template-columns: repeat(1, 1fr)"
                    class="p-0"
                  >
                    <li :key="index" class="m-3 d-inline">
                      <img
                        class="w-100 h-100"
                        v-bind:src="lastItem['thumbnail_display_urls']['large']"
                        v-img="{ group: getTitle(lastItem) }"
                        :alt="getTitle(lastItem)"
                        :title="getTitle(lastItem)"
                      />
                    </li>
                  </ul>
                </div>
                <div v-else class="">
                  <div
                    v-for="(item, index) in filteredMedia(place)"
                    :key="index"
                    class="row mx-auto d-inline"
                  >
                    <div class="col-12 text-center mb-4">
                      <img
                        class="w-90"
                        v-bind:src="item['thumbnail_display_urls']['large']"
                        v-img="{ group: item['dcterms:description']['@value'] }"
                        :alt="
                          item['dcterms:description']
                            ? item['dcterms:description']['@value']
                            : ''
                        "
                        :title="
                          item['dcterms:description']
                            ? item['dcterms:description']['@value']
                            : ''
                        "
                      />
                    </div>
                  </div>
                  <div
                    v-if="lastItem"
                    :key="index"
                    class="row mx-auto d-inline"
                  >
                    <div class="col-12 text-center mb-4">
                      <img
                        class="w-90"
                        v-bind:src="lastItem['thumbnail_display_urls']['large']"
                        v-img="{
                          group: lastItem['dcterms:description']['@value'],
                        }"
                        :alt="
                          lastItem['dcterms:description']
                            ? lastItem['dcterms:description']['@value']
                            : ''
                        "
                        :title="
                          lastItem['dcterms:description']
                            ? lastItem['dcterms:description']['@value']
                            : ''
                        "
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const Common = require("@/Common.vue").default;
import { library } from "@fortawesome/fontawesome-svg-core";
import $ from "jquery";
import { faFlask } from "@fortawesome/free-solid-svg-icons";
import { Pano } from "vuejs-vr";
import { config } from "../utils/config";
library.add(faFlask);

import { LMap, LMarker, LPopup, LTileLayer, LIcon } from "vue2-leaflet";
import iframeResize from 'iframe-resizer/js/iframeResizer';
import Vue from 'vue'

Vue.directive('resize', {
  bind: function(el, { value = {} }) {
    el.addEventListener('load', () => iframeResize(value, el))
  },
  unbind: function (el) {
    el.iFrameResizer.removeListeners();
  }
})

export default {
  name: "profile",
  bodyClass: "profile-page",
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LIcon,
    Pano,
  },

  data() {
    return {
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      zoom: 16,
      markerLatLngGeodidalab: [45.47597654352459, 7.889857414848962],
      markerLatLngIstitutoMosso: [45.874967902504444, 7.871756277926618],
      anchorOptions: { offset: L.point(0, -30) },
      map: null,
      media: [],
      allLoaded: false,
      windowWidth: 0,
      selectedTab: null,
      isGeodidalab: true,
      lastItem: null,
    };
  },

  created() {
    this.isGeodidalab = config.isGeodidalab;

    this.windowWidth = $(window).width();

    $(window).resize(() => {
      this.windowWidth = $(window).width();
    });

    var self = this;

    Common.getElemsByClassNoCache(
      this,
      config.omekaIDs.omekaIDluoghi,
      (res) => {
        self.media = res.body;
        self.allLoaded = true;

        this.selectedTab = this.places[0];
      }
    );
  },

  computed: {
    places() {
      return [...new Set(this.media.map((place) => place["o:title"]))];
    },
    isLarge() {
      return this.windowWidth >= 768;
    },
    panorama() {
      if (this.media !== undefined) {
        var p = this.media
          .filter(
            (media) => media["geo:Tipologia"][0]["@value"] === "PANORAMICA"
          )
          .filter((m) => m["o:title"] === this.selectedTab);

        if (p.length > 0) {
          return p[0]["thumbnail_display_urls"]["large"];
        } else {
          return null;
        }
      } else {
        return null;
      }
    },
  },

  methods: {
    filteredMedia(place) {
      var media = this.media
        .filter((media) => media["geo:Tipologia"][0]["@value"] === "NORMALE")
        .filter((pl) => pl["o:title"] === place);

      if (media.length % 2 === 0) {
        return media;
      } else {
        this.lastItem = media.pop();
      }

      return media;
    },
    filteredMediaWebcam(place) {
      var media = this.media
        .filter((media) => media["geo:Tipologia"][0]["@value"] === "Webcam")
        .filter((pl) => pl["o:title"] === place);

      // if(media.length % 2 === 0) {
      //   return media;
      // } else {
      //   this.lastItem = media.pop();
      // }

      return media;
    },
    getTitle(item) {
      return item["dcterms:description"]
        ? item["dcterms:description"]["@value"]
        : "";
    },
    changePlace(place) {
      this.selectedTab = place;
      this.lastItem = null;
    },
    resizeIframe(obj) {
      obj.style.height = obj.contentWindow.document.documentElement.scrollHeight + 'px';
    }
  },

  watch: {
    selectedTab(newValue, OldValue) {
      $( document ).ready(function() {

        setTimeout(() => {
          $(".customiframe").each(function (index) {
            $(this).contents().find('.footer').hide();

            //$(this).contents().find('.footer').css({display: 'none'});
          });
        });
        if (newValue === "Webcam") {
          setTimeout(() => {
            var iframes = document.getElementsByClassName("customiframe");

            var arr = [].slice.call(iframes);

            for (let item of iframes) {
              setTimeout(() => {
                var innerDoc = item.contentDocument || item.contentWindow.document;
                var a = item.getElementsByClassName("footer");
                var element = item.getElementsByClassName("footer")[0];
                element.style.display = "none";
              });
            }


            for (var i = 0; i < iframes; i++) {
              var a = iframes[i].contentWindow.document.getElementsByClassName("footer");
              var element = iframes[i].contentWindow.document.getElementsByClassName("footer")[0];
              element.style.display = "none";
            }
          }, 0);


        }
      });
    }
  }
};
</script>
<style scoped>
.mappaDoveSiamo {
  height: 500px;
  border-radius: 10px;
}.indianRedColor {
  color: indianred;
}

.iframe-container {
  position: relative;
  width: 100%;
  padding-bottom: 50%;
  background: lightgrey;
}

.iframe-container iframe {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 1px solid red;
}
</style>
